<script>
import vSelect from 'vue-select'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      dados: null,
      timerFiltro: 7,
      options: []
    }
  },
  components: { vSelect },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('model', newValue)
      }
    }
  },
  methods: {
    ...mapActions({
      getCidadesFiltro: 'cidade/getCidadesFiltro'
    }),
    getCidades: async function (search, loading) {
      clearTimeout(this.timerFiltro)
      if (search.length > 2) {
        this.timerFiltro = setTimeout(() => {
          loading(true)
          this.getCidadesFiltro(search).then(retorno => {
            loading(false)
            if (retorno === 0) this.vazioCidades = 'Nenhum registro encontrado'
            else this.options = retorno
            if (retorno.message) this.$toast.warn({ title: 'Atenção', message: retorno.message })
          })
        }, 1000)
      }
    }
  },
  props: {
    value: {
      type: [String, Object],
      default: null,
      required: false
    },
    input: {
      type: Function,
      required: false
    },
    placeholder: {
      type: String,
      default: 'Insira a cidade',
      required: false
    }
  }
}
</script>
<template>
  <div>
    <v-select :on-search="getCidades" v-model="model"  @input="input" id="comp-search-sel-cid-v-select" :options="options" :placeholder="placeholder"  :filterable="false" >
      <span slot="no-options">
        Digite o nome da cidade
      </span>
    </v-select>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// search-select-cidade.vue?88ff1b00